import {
  PaymentCurrency,
  PaymentMethod,
  PaymentRefType,
} from '@daymade/common-lib/dbEnums';
import { z } from 'zod';
import {
  zodSelectAccount,
  zodSelectAccountJournal,
} from '../generated/zodSchemas.generated';

export const ZPaymentCurrency = z.nativeEnum(PaymentCurrency);

export const ZPaymentMethod = z.nativeEnum(PaymentMethod);

export const ZPaymentRefType = z.nativeEnum(PaymentRefType);

export const ZPlayerAccountSelectPrivate = zodSelectAccount.pick({
  playerId: true,
  currencyCode: true,
  mainBalance: true,
  giftCardBalance: true,
  promoBalance: true,
  tokenBalance: true,
});

export const ZAccountJournalSelectPrivate = zodSelectAccountJournal
  .pick({
    id: true,
    playerId: true,
    totalFiatAmount: true,

    balanceAmount: true,
    giftCardAmount: true,
    promoAmount: true,
    paymentMethodAmount: true,

    tokenAmount: true,

    transactionType: true,
    comment: true,
    refType: true,
    refId: true,

    paymentMethod: true,
    paymentSessionId: true,
  })
  .extend({
    createdAt: z.coerce.date(),
  });

export const ZDetailedAccountJournal = ZAccountJournalSelectPrivate.pick({
  id: true,
  refType: true,
  refId: true,
  transactionType: true,
  totalFiatAmount: true,
  balanceAmount: true,
  giftCardAmount: true,
  promoAmount: true,
  paymentMethodAmount: true,
  tokenAmount: true,
  comment: true,
  paymentMethod: true,
  paymentSessionId: true,
})
  .extend({
    createdAt: z.coerce.date(),
    notes: z.string(),
  })
  .array();
